module.exports = __webpack_public_path__ + "2928cc9cb7892af81bbc237005ae3912.mp4";